import React, { useContext, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import NewLeadAddSection from "../../organisms/Forms/newLeads-section/NewLeadAddSection";
import CallWidget from "../../molecules/CallWidget/CallWidget";
import { Formik, Form } from "formik";
import Loader from "../../atoms/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { allCustomersGet } from "../../../slices/clients/clientManagementSlice";
import { mapGoogleAddressToAddressOne } from "../../../utils/helpers/helperMethods/Leads/adressHelper";
import { getValidationSchema } from "../../../utils/helpers/helperMethods/Validations";
import { AppDispatch, RootState } from "../../../slices/store";
import useReqRequests from "../../../utils/helpers/helperMethods/userRequets";
import NewLeadContent from "../../../utils/helpers/helperDataset/lead-management-contents/newLeadContet.json";
import { TodosContext } from "../../../context";
import { useNavigate } from "react-router-dom";
import UseAuthConfig from "../../../hooks/useAuthConfig";
import useUserRole from "../../../hooks/useUserRole";
import { handleCreateLeadService } from "../../../pages/leads-management/service/LeadService";
import { scrollToTop } from "../../../utils/helpers/helperMethods/scrollToTop";
import { handleMobileNumberChange } from "../../../utils/helpers/helperMethods/mobileNumberHandler";
import {
  getCustomerJobs,
  resetCustomerJobs,
} from "../../../slices/jobs/jobManagementSlice";
import { useSelectedLeadType } from "../../../slices/leads/selector";
import { initialUserFormValues } from "./constants";
import LeadProgressChecklist from "./LeadProgressChecklist";
import { deleteTempCallRecordingResource, getTempCallRecordingResource, uploadTempCallRecording } from "../../../slices/users/userManagementSlice";

const NewLeadTemplate = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { fields, buttons, successWizard } = NewLeadContent;
  const [inputValue, setInputValue] = React.useState<any>({});
  const [startDate, setStartDate] = React.useState(new Date());
  const [initially, setInitially] = React.useState<boolean>(true);
  const [errors, setErrors] = React.useState<any>({});
  const [record, setRecord] = React.useState<any>();
  const [audioFile, setAudioFile] = React.useState<File | null>(null);
  const [isPageLoad, setIsPageLoad] = React.useState<boolean>(false);
  const [recordUrl, setRecordUrl] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [submitAttempted, setSubmitAttempted] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("AccessToken")!;
  const { reqRequests } = useReqRequests();
  const { addAlert } = useContext(TodosContext);
  const { protectedResources } = UseAuthConfig();
  const userRole = useUserRole();
  const leadType = useSelectedLeadType();
  const [isUploading, setIsUploading] = React.useState<boolean>(false);
  const customers = useSelector(
    (state: RootState) => state.clientManagement.customers
  );
  const status = useSelector(
    (state: RootState) => state.leadsManagement.status
  );

  useEffect(() => {
    fields.length > 0 &&
      fields.map((field: { name: string }) => {
        setInputValue((prev: any) => ({
          ...prev,
          [field.name]: "",
        }));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(resetCustomerJobs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (accessToken) {
      if (!customers?.succeeded && !isPageLoad) {
        const param = {
          url: reqRequests.url,
          token: accessToken,
        };
        dispatch(allCustomersGet(param));
      }
      setIsPageLoad(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  const handleChangeInputValues = (e: any) => {
    const { name, value } = e.target;
    if (name === "mobile" || name === "phone") {
      const formatted = handleMobileNumberChange(value);
      console.log("Handling mobile/phone input change", formatted);
      setInputValue((prev: any) => ({ ...prev, [name]: formatted }));
      return;
    }
    if (name) {
      setInputValue((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    }
    setInitially(false);
  };

  const handleSetAddressValuesByGoogleAPI = (result: any, name: string) => {
    const value = result.value.terms;
    setInputValue((prev: any) => ({
      ...prev,
      [name]: result.label,
    }));

    if (name === "address1") {
      setInputValue((prev: any) => ({
        ...prev,
        addressOne: mapGoogleAddressToAddressOne(value),
      }));
    } else {
      setInputValue((prev: any) => ({
        ...prev,
        addressTwo: mapGoogleAddressToAddressOne(value),
      }));
    }
  };

  const handleRecording = async (event: any) => {
    var selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type.startsWith("audio/")) {
      // Prioritize MP3 files, but accept other audio formats
      await saveFileToBlobStorage(selectedFile);
      setAudioFile(selectedFile);
    }
    setRecord(selectedFile);
  };

  const handleDate = (date: any) => {
    setStartDate(date);
  };

  const handleUpload = (selectedFile: any) => {
    setRecordUrl(selectedFile);
  };

  const handleCallRecordingComplete = async (recordingData: any) => {
    if (recordingData && recordingData.audioBlob) {
      const blob: Blob = recordingData.audioBlob;
      // Preserve the original mime type with MP3 preference
      const mimeType = blob.type || "";
      const allowedTypes = ["audio/mp3", "audio/wav"];
      const isValidType = allowedTypes.some((type) =>
        mimeType.toLowerCase().includes(type.replace("audio/", ""))
      );
      if (!isValidType) {
        addAlert("Only .mp3 and .wav recordings are allowed.", "failed", true);
        return;
      }
      const extension = mimeType.includes("wav") ? "wav" : "mp3";
      const fileName = `call-recording-${Date.now()}.${extension}`;

      const recordingFile = new File([blob], fileName, { type: mimeType });

      await saveFileToBlobStorage(recordingFile);

      const fileFromStorage = await getFileFromBlobStorage();
      setAudioFile(fileFromStorage);
      setRecord(fileFromStorage);
    }
  };

  const saveFileToBlobStorage = (file: File): Promise<void> => {
    return new Promise((resolve, reject) => {
      setIsUploading(true);
      dispatch(uploadTempCallRecording({ accessToken: localStorage.getItem("AccessToken")!, selectedFile: file, url: protectedResources.apiTodoList.endpoint! }))
        .unwrap()
        .then(() => resolve(
          setIsUploading(false)
        ))
        .catch((error) => reject(error));
    });
  };

  const getFileFromBlobStorage = async (): Promise<File | null> => {
    try {
      var existingRecording = localStorage.getItem("existingRecording");

      if (!existingRecording || Date.now() > Number(existingRecording)) {
        localStorage.removeItem("recordingFile");
        localStorage.removeItem("existingRecording");
        return null;
      }

      var name = localStorage.getItem("recordingFile");
      if (!name) {
        return null;
      }
      setIsUploading(true);
      const response = await dispatch(
        getTempCallRecordingResource({
          accessToken: localStorage.getItem("AccessToken")!,
          url: protectedResources.apiTodoList.endpoint!,
          name: name
        })
      ).unwrap();
      setIsUploading(false);
      const binaryString = window.atob(response.content);

      const bytes = new Uint8Array(binaryString.length);

      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const file = new File(
        [bytes],
        response.fileName,
        {
          type: "audio/mp3"
        }
      );
      setAudioFile(file);

      return file;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  useEffect(() => {
    const restoreRecordingFile = async () => {
      const fileFromStorage = await getFileFromBlobStorage();
      if (!fileFromStorage) return;

      setAudioFile(fileFromStorage);
      setRecord(fileFromStorage);
      setRecordUrl(fileFromStorage);
    };

    restoreRecordingFile();
  }, []);

  useEffect(() => {
    if (record) {
      handleUpload(record);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  const schema = getValidationSchema(leadType);

  const handleCreateLead = async () => {
    setSubmitAttempted(true);
    try {
      await schema.validate(inputValue, { abortEarly: false });

      handleCreateLeadService(
        inputValue,
        accessToken,
        protectedResources.apiTodoList.endpoint,
        reqRequests,
        dispatch,
        setIsLoading,
        navigate,
        record,
        status,
        addAlert,
        userRole,
        leadType
      );
    } catch (validationError: any) {
      // Get the first error message
      const firstErrorMessage =
        validationError.inner?.[0]?.message ||
        "Please fill in all required fields";

      scrollToTop();
      addAlert(firstErrorMessage, "failed", true);
    }
  };

  const handleCustomerValues = (value: any) => {
    setInputValue((prev: any) => ({
      ...prev,
      customer: value,
    }));
    const params = {
      accessToken: localStorage.getItem("AccessToken")!,
      url: protectedResources.apiTodoList.endpoint!,
      id: value.value,
    };
    dispatch(getCustomerJobs(params));
  };

  const handleJobValues = (value: any) => {
    setInputValue((prev: any) => ({
      ...prev,
      job: value,
    }));
  };

  const handleBusinessType = (value: any) => {
    setInputValue((prev: any) => ({
      ...prev,
      businessType: value?.value || "",
    }));
  };

  const handleDeleteRecording = () => {
    if (recordUrl?.name) {
      dispatch(deleteTempCallRecordingResource({
        accessToken: localStorage.getItem("AccessToken")!,
        url: protectedResources.apiTodoList.endpoint!,
        name: localStorage.getItem("recordingFile")!
      }));
    }
    setAudioFile(null);
    setRecord(null);
    setRecordUrl(null);
    localStorage.removeItem("recordingFile");
    localStorage.removeItem("existingRecording");
  };

  return isLoading ? (
    <Loader />
  ) : (
    <div className="new-lead">
      <Row>
        <Col sm={9}>
          <CallWidget
            leadId={0} // Temporary ID for new leads, will be updated after lead creation
            onRecordingComplete={handleCallRecordingComplete}
          />
          <Formik
            initialValues={initialUserFormValues}
            validationSchema={schema}
            onSubmit={(values) => { }}
            validateOnChange={submitAttempted}
            validateOnBlur={submitAttempted}
          >
            {({ errors, touched, validateForm }) => (
              <Form onChange={handleChangeInputValues}>
                <NewLeadAddSection
                  handleDate={handleDate}
                  onChange={handleChangeInputValues}
                  customers={customers}
                  newLeadContent={NewLeadContent}
                  inputValue={inputValue}
                  buttons={buttons}
                  errors={errors}
                  startDate={startDate}
                  touched={touched}
                  setErrors={setErrors}
                  handleRecording={handleRecording}
                  recordUrl={audioFile}
                  handleSetAddressValuesByGoogleAPI={
                    handleSetAddressValuesByGoogleAPI
                  }
                  handleCustomerValues={handleCustomerValues}
                  handleJobValues={handleJobValues}
                  handleCreateLead={handleCreateLead}
                  validateForm={validateForm}
                  handleBusinessType={handleBusinessType}
                  onDeleteRecording={handleDeleteRecording}
                  hasFile={!!recordUrl?.name}
                  isUploading={isUploading}
                />
              </Form>
            )}
          </Formik>
        </Col>
        <Col sm={3}>
          <LeadProgressChecklist
            inputValue={inputValue}
            record={record}
            leadType={leadType}
          />
        </Col>
      </Row>
    </div>
  );
};

export default NewLeadTemplate;
